'use client';

import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import React from 'react';
import { cm } from 'src/utils/classNames';
import { TradePageTableContent } from './TradePageTableContent';
import { useBalanceCount } from './hooks/useBalanceCount';
import { useOpenOrderCount } from './hooks/useOpenOrderCount';
import { useNonZeroOpenPerpPositionCount } from './hooks/useNonZeroOpenPerpPositionCount';
import { TradePageTableTabs } from './TradePageTableTabs';
import { TradeTableTabValue } from 'src/components/TradePageTable/hooks/useTradePageTableTabs';

const TradePageTable = ({
	overviewPage = false,
	className,
}: {
	overviewPage?: boolean;
	className?: string;
}) => {
	const setState = useDriftStore((s) => s.set);

	const setUserInfoTab = (newTab: TradeTableTabValue) =>
		setState((s) => {
			s.tradePageTable.currentTab = newTab;
		});

	const positionCount = useNonZeroOpenPerpPositionCount(false);

	const balanceCount = useBalanceCount();

	const openOrderCount = useOpenOrderCount();

	const activeTab = useDriftStore((s) => s.tradePageTable.currentTab);

	return (
		<div
			className={cm(
				'relative flex h-full flex-col overflow-hidden bg-container-bg sm:rounded-sm',
				className
			)}
		>
			<TradePageTableTabs
				activeTab={activeTab}
				setActiveTab={setUserInfoTab}
				positionCount={positionCount}
				openOrderCount={openOrderCount}
				balanceCount={balanceCount ?? 0}
				overviewPage={overviewPage}
			/>
			<div className="h-full overflow-hidden bg-main-bg sm:bg-container-bg">
				<TradePageTableContent
					activeTab={activeTab}
					overviewPage={overviewPage}
				/>
			</div>
		</div>
	);
};

export default React.memo(TradePageTable);
